import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { AiFillCaretRight } from "react-icons/ai";
import { useSelector } from "react-redux";
// import "../common1.css";
import "../common.css";
import InputTitle from "../InputTitle";

const TextInput = ({
  marginTop,
  label,
  icon,
  name,
  type,
  placeholder,
  value,
  onChange,
  onBlur,
  onKeyPress,
  disabled,
  maxLength,
  min,
  max,
  error,
  loading,
}) => {
  const { inputLabelColor, inputIconColor, inputError, themeTemplate } =
    useSelector((state) => state.theme);
  return (
    <div className={marginTop}>
      <InputTitle 
        title={label}
      />
      <div style={{ position: "relative" }}>
        <span
          className={`${
            themeTemplate == "103" ||
            themeTemplate == "106" ||
            themeTemplate == "105"
              ? "icon-style2"
              : themeTemplate == "109"
              ? "icon-style3"
              : "icon-style"
          }`}
        >
          {icon ? (
            icon
          ) : (
            <>
              <AiFillCaretRight color={inputIconColor} />
            </>
          )}
        </span>
        <div className="d-flex align-items-center justify-content-between">
          <input
            name={name}
            type={type}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            onBlur={onBlur}
            onKeyPress={onKeyPress}
            className={`${
              themeTemplate == "103" ||
              themeTemplate == "106" ||
              themeTemplate == "105"
                ? "custom-form-control2"
                : themeTemplate == "109"
                ? "custom-form-control3"
                : "custom-form-control"
            }`}
            disabled={disabled}
            maxLength={maxLength}
            min={min}
            max={max}
            style={{ textIndent: 20 }}
          />
          {loading && (
            <div
              className="spinner-border spinner-border-sm"
              style={{
                width: "1.2rem",
                height: "1.2rem",
                color: inputIconColor ? inputIconColor : "#000000",
              }}
              role="status"
            >
              <span className="sr-only">Loading...</span>
            </div>
          )}
        </div>
      </div>
      {error && <div style={{ color: inputError, fontSize: 12 }}>{error}</div>}
    </div>
  );
};

TextInput.propTypes = {
  title: PropTypes.string,
  icon: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  name: PropTypes.string,
  type: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onKeyPress: PropTypes.func,
  disabled: PropTypes.bool,
  maxLength: PropTypes.string,
  min: PropTypes.string,
  max: PropTypes.string,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  loading: PropTypes.bool,
};

TextInput.defaultProps = {
  marginTop: "mt-4",
  label: "text",
  icon: "",
  name: "",
  type: "",
  placeholder: "",
  value: "",
  onChange: undefined,
  onBlur: undefined,
  onKeyPress: undefined,
  disabled: false,
  maxLength: undefined,
  min: undefined,
  max: undefined,
  error: "",
  loading: false,
};

export default TextInput;
